import React from 'react';

import type { StickerColor } from '../../../../../types/dontgiftguide';
import * as styles from './OvalSticker.styles';
export interface OvalStickerProps {
  color: StickerColor;
  content: string;
}

const getImageSrc = (color: StickerColor) => {
  switch (color) {
    case 'yellow':
      return 'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blte37d3f52b39992e9/yellow_oval.png';
    case 'purple':
      return 'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/bltc3d756cd37c5d387/purple_oval.png';
    case 'green':
      return 'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt32a85ee7e2164a87/green_oval.png';
    case 'dark purple':
      return 'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt3c50fc3fdd2aec4a/dark_purple_oval.png';
    case 'dark green':
      return 'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt867ae7f408e00e0f/dark_green_oval.png';
    default:
      console.error(`Unsupported oval sticker color: ${color}`);
      return null;
  }
};

export const OvalSticker = ({ color, content }: OvalStickerProps) => {
  const imageSrc = getImageSrc(color);

  return imageSrc ? (
    <div css={styles.container}>
      <img src={imageSrc} alt="" />
      <div
        css={[
          styles.contentWrapper,
          ['dark purple', 'dark green'].includes(color) ? styles.contentLight : styles.contentDark,
        ]}
      >
        <div css={styles.content}>{content}</div>
      </div>
    </div>
  ) : null;
};
